<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment-timezone";
import { postPaged } from "@/services/paginated";
/**
 * Register component
 */
export default {
  page: {
    title: "Danh sách khách hàng",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      json_fields: {
        "Invoice Number": "invoice",
        Timestamp: "crt",
        "Are you?": "customer",
        "Sender's first and last name": "sender_fn",
        "Sender's phone number": "sender_phone",
        "Sender's address": "sender_address",
        "Sender's email": "sender_email",
        "Recipient's first and last name": "recipient_fn",
        "Recipient's email": "recipient_email",
        "Recipient's phone number": "recipient_phone",
        "Recipient's address": "recipient_address",
        products: "products",
      },
      json_meta: [[{ key: "charset", value: "utf-8" }]],

      columns: [
        { label: "Ngày tạo", field: "crt", width: "160px" },
        { label: "Mã đơn", field: "invoice", width: "140px" },
        { label: "Người gửi", field: "sender_fn" },
        { label: "Điện thoại", field: "sender_phone", width: "140px" },
        { label: "Trạng thái", field: "status", width: "120px" },
        { label: "Hành động", field: "_id", width: "180px" },
      ],

      rows: [],
      totalRows: 0,
      page: 1,
      perPage: 20,
      searchTerm: "",
      isLoading: false,
    };
  },

  methods: {
    // ✅ Gọi API bằng hàm rút gọn postPaged()
    async fetchOrders() {
      this.isLoading = true;
      const data = await postPaged("/api/order/list", {
        page: this.page,
        limit: this.perPage,
        search: this.searchTerm,
      });
      this.rows = data.items || [];
      this.totalRows = data.total || 0;
      this.isLoading = false;
    },

    onPageChange(params) {
      this.page = params.currentPage;
      this.fetchOrders();
    },
    onPerPageChange(params) {
      this.perPage = params.currentPerPage;
      this.page = 1;
      this.fetchOrders();
    },
    onSearch(params) {
      this.searchTerm = params.searchTerm;
      this.page = 1;
      this.fetchOrders();
    },

    formatDate(date) {
      return moment
        .tz(date, "UTC")
        .tz("America/Los_Angeles")
        .format("DD-MM-YYYY HH:mm");
    },
    renderName() {
      return moment().format("HH:mm DD-MM-YYYY") + "-orders.xls";
    },

    // ✅ nút Xử lý & Xem
    handlerOrder(_id) {
      this.$router.push({ name: "bill-add", query: { id: _id } });
    },
    detaild(_id) {
      // tương tự BillingList: auto dò route nếu cần
      const routes = this.$router?.options?.routes || [];
      const found = routes.find((r) =>
        ["order-detaild", "order-detail", "detail-order"].includes(r.name)
      );
      if (found) this.$router.push({ name: found.name, query: { id: _id } });
      else this.$router.push({ path: "/order/detail", query: { id: _id } });
    },
  },

  async mounted() {
    await this.fetchOrders();
  },
};
</script>

<template>
  <Layout>
    <PageHeader />

    <div class="card">
      <div class="card-body">
        <div class="text-sm-end mb-3">
          <export-excel class="btn btn-info btn-sm" :data="rows" :fields="json_fields" worksheet="Order list"
            :name="renderName()">
            <i class="bx bx-download"></i> Tải xuống Excel
          </export-excel>
        </div>

        <vue-good-table :columns="columns" :rows="rows" :total-rows="totalRows" :pagination-options="{
          enabled: true,
          rowsPerPageLabel: 'các mục trong trang',
          nextLabel: 'tiếp',
          prevLabel: 'trước',
          mode: 'records',
          perPage: perPage,
          perPageDropdown: [10, 20, 50, 100, 200],
          allLabel: 'Tất cả',
        }" :line-numbers="true" :search-options="{ enabled: true, placeholder: 'Tìm kiếm đơn hàng...' }" mode="remote"
          @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-search="onSearch">
          <template slot="table-row" slot-scope="props">
            <!-- Cột hành động -->
            <span v-if="props.column.field === '_id'">
              <button type="button" class="btn btn-primary btn-sm mx-1" @click="detaild(props.row._id)">
                Xem
              </button>
              <button type="button" class="btn btn-info btn-sm" @click="handlerOrder(props.row._id)">
                Xử lý
              </button>
            </span>

            <!-- Cột ngày tạo -->
            <span v-else-if="props.column.field === 'crt'">
              {{ formatDate(props.row.crt) }}
            </span>

            <!-- Cột trạng thái -->
            <span v-else-if="props.column.field === 'status'">

              <button v-if="props.row.status === false" class="btn btn-sm btn-danger">
                Chưa xử lý
              </button>
              <button v-else class="btn btn-sm btn-success">
                Đã xử lý
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>